import { cx } from '@linaria/core';
import { TransitionGroup } from 'react-transition-group';
import { CheckmarkIcon } from '@ui/kit';
import { useActivityIndicator, CSSRefTransition } from '@utils/react';
import { stateChangeDurationMs, state, spinner, icon, wrapper } from './_async-indicator.style.js';
export { asyncIndicatorSelectors } from './_async-indicator.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function AsyncIndicator(props) {
  const showThrobber = useActivityIndicator(props.isLoading, {
    delayMs: 300,
    durationMs: 1000
  });
  return /*#__PURE__*/jsx("div", {
    className: cx(wrapper, props.className),
    children: /*#__PURE__*/jsxs(TransitionGroup, {
      component: null,
      children: [showThrobber.isActive() && /*#__PURE__*/jsx(CSSRefTransition, {
        classNames: state,
        timeout: stateChangeDurationMs,
        children: ref => /*#__PURE__*/jsxs("span", {
          ref: ref,
          className: state,
          children: [/*#__PURE__*/jsx("span", {
            className: spinner
          }), /*#__PURE__*/jsx("span", {
            children: "Gemmer ..."
          })]
        })
      }), !showThrobber.isActive() && props.state === "success" && /*#__PURE__*/jsx(CSSRefTransition, {
        classNames: state,
        timeout: stateChangeDurationMs,
        children: ref => /*#__PURE__*/jsxs("span", {
          ref: ref,
          className: state,
          children: [/*#__PURE__*/jsx("span", {
            className: icon,
            "data-state": "success",
            children: /*#__PURE__*/jsx(CheckmarkIcon, {
              height: 7
            })
          }), /*#__PURE__*/jsx("span", {
            children: "Gemt"
          })]
        })
      }), !showThrobber.isActive() && props.state === "error" && /*#__PURE__*/jsx(CSSRefTransition, {
        classNames: state,
        timeout: stateChangeDurationMs,
        children: ref => /*#__PURE__*/jsxs("span", {
          ref: ref,
          className: state,
          children: [/*#__PURE__*/jsx("span", {
            className: icon,
            "data-state": "error",
            children: "!"
          }), /*#__PURE__*/jsx("span", {
            children: "Kunne ikke gemmes"
          })]
        })
      })]
    })
  });
}

export { AsyncIndicator };
//# sourceMappingURL=_async-indicator.js.map
